import { SMSMessageInput } from "@sinch/components/form/SMSMessageInput/SMSMessageInput";
import React, { FC } from "react";
import { useController } from "react-hook-form";
import { MessageFormFields } from "./formSchema";

/**
 * SMSContent component renders a text input for SMS messages along with
 * character count information, segment count and alerts about message encoding.
 */
export const SMSContent: FC<{ recipients: { name: string; phone: string }[] }> = ({ recipients }) => {
  const { field } = useController<MessageFormFields, "textMessage">({
    name: "textMessage",
  });

  return <SMSMessageInput {...field} recipientCount={recipients.length} />;
};
